interface IProps {
  width?: number
  height?: number
}

const Amil = ({ width, height }: IProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      version='1.1'
      viewBox='0 0 4096 4096'
    >
      <defs>
        <clipPath
          id='clipPath36062'
          clipPathUnits='userSpaceOnUse'
        >
          <path d='M178.79 366.979h237.693v123.677H178.79z'></path>
        </clipPath>
      </defs>
      <g transform='translate(0 3799)'>
        <g
          fill='#461bff'
          fillOpacity='1'
          clipPath='url(#clipPath36062)'
          transform='matrix(17.74837 0 0 -17.74837 -3234.593 5859.816)'
        >
          <g
            fill='#461bff'
            fillOpacity='1'
            transform='translate(352.06 447.17)'
          >
            <path
              fill='#461bff'
              fillOpacity='1'
              fillRule='nonzero'
              stroke='none'
              d='M0 0c-3.645 0-6.357 2.798-6.357 6.188 0 3.476 2.712 6.188 6.357 6.188 3.646 0 6.357-2.712 6.357-6.188C6.357 2.798 3.646 0 0 0m29.839-47.894h1.186c.509 0 .848.339.848.848v6.78c0 .51-.254.849-.679 1.018-4.746 1.865-6.272 4.747-6.272 11.783v37.553c0 .508-.339.848-.848.848H14.92c-.509 0-.849-.34-.849-.848v-38.232c0-11.782 6.189-19.75 15.768-19.75m-109.182.254h9.155c.508 0 .847.339.847.848v21.955c0 3.984-.678 7.46-1.865 10.257 3.9 1.526 7.545 2.373 9.833 2.373 5.68 0 8.393-3.475 8.393-10.85v-23.735c0-.509.338-.848.847-.848h9.155c.509 0 .848.339.848.848v23.905c0 3.39-.594 6.358-1.526 8.9 3.56 1.187 7.121 1.78 9.495 1.78 5.679 0 8.391-3.475 8.391-10.85v-23.735c0-.509.339-.848.848-.848h9.155c.509 0 .847.339.847.848v23.905c0 11.698-5.34 19.581-16.953 19.411-5.425-.084-10.596-1.356-16.106-3.983-2.967 2.627-6.951 3.983-11.867 3.983-5.341 0-10.342-1.949-16.361-4.577-2.119 1.611-6.019 2.967-8.731 2.967h-1.356c-.509 0-.848-.339-.848-.848v-6.951c0-.423.254-.847.678-1.017 4.747-1.865 6.273-4.747 6.273-11.783v-21.107c0-.509.339-.848.848-.848m-38.909-1.441c6.951 0 12.122 3.137 15.936 7.121 3.137-3.391 7.036-5.68 12.97-5.68h1.102c.509 0 .848.339.848.848v6.526c0 .51-.255.849-.678 1.018-4.748 1.865-6.274 4.747-6.274 11.783v21.701c0 .509-.339.847-.847.847h-9.071c-.508 0-.847-.338-.847-.847v-2.967c-2.543 2.544-7.121 5.255-13.224 5.255-11.783 0-22.379-9.918-22.379-22.971 0-13.988 10.512-22.634 22.464-22.634M-4.578-47.64h9.156c.508 0 .847.339.847.848v41.028c0 .509-.339.847-.847.847h-9.156c-.508 0-.847-.338-.847-.847v-41.028c0-.509.339-.848.847-.848m-112.657 7.969c-7.629 0-13.308 6.104-13.308 13.393 0 7.375 5.679 13.393 13.308 13.393 7.63 0 13.224-6.018 13.224-13.393 0-7.289-5.594-13.393-13.224-13.393'
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Amil
